import React, { useCallback, useEffect } from 'react'
import { Modal } from '../../CommonComponents/Modal/Modal.tsx'
import { useErrorStore } from './ErrorStore.ts'
import { ErrorModalContent } from '../../CommonComponents/ErrorContent/ErrorContent.tsx'
import useShowHide from '../../utils/useShowHide.ts'
import { AxiosError } from 'axios'

const ErrorModal: React.FC = () => {
    const axiosError = useErrorStore(x => x.axiosError)
    const setAppError = useErrorStore(x => x.setAppError)
    const handleRetry = useErrorStore(x => x.handleRetry)
    const reset = useErrorStore(x => x.reset)

    const loading = useShowHide(false)

    const retry = useCallback(async () => {
        loading.open()
        try {
            await handleRetry()
        } catch (e) {
            setAppError({
                axiosError: e as AxiosError,
                //@ts-ignore
                message: e?.message as string | undefined,
                retry: handleRetry
            })
        } finally {
            loading.close()
        }
    }, [handleRetry])

    return (
        <Modal onClose={reset}>
            <ErrorModalContent loading={loading.visible} error={axiosError!} handle={retry} close={reset} />
        </Modal>
    )
}

export const ErrorLayer: React.FC<React.PropsWithChildren> = ({ children }) => {
    const showModal = useErrorStore(x => x.showModal)
    useEffect(() => {
        showModal && window.scroll(0, 0)
    }, [showModal])
    return (
        <>
            {children}
            {showModal && <ErrorModal />}
        </>
    )
}
